export const LockedBlackIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 3.5C9.46957 3.5 8.96086 3.71071 8.58579 4.08579C8.21071 4.46086 8 4.96957 8 5.5V7.5H12V5.5C12 4.96957 11.7893 4.46086 11.4142 4.08579C11.0391 3.71071 10.5304 3.5 10 3.5ZM7 5.5V7.5H4.54545C3.95367 7.5 3.5 7.99031 3.5 8.5625V16.4375C3.5 17.0097 3.95367 17.5 4.54545 17.5H15.4545C16.0463 17.5 16.5 17.0097 16.5 16.4375V8.5625C16.5 7.99031 16.0463 7.5 15.4545 7.5H13V5.5C13 4.70435 12.6839 3.94129 12.1213 3.37868C11.5587 2.81607 10.7956 2.5 10 2.5C9.20435 2.5 8.44129 2.81607 7.87868 3.37868C7.31607 3.94129 7 4.70435 7 5.5ZM4.54545 8.5H7.5H12.5H15.4545C15.4621 8.5 15.4712 8.5024 15.4813 8.51283C15.4917 8.52352 15.5 8.54013 15.5 8.5625V16.4375C15.5 16.4599 15.4917 16.4765 15.4813 16.4872C15.4712 16.4976 15.4621 16.5 15.4545 16.5H4.54545C4.53791 16.5 4.52882 16.4976 4.51871 16.4872C4.50834 16.4765 4.5 16.4599 4.5 16.4375V8.5625C4.5 8.54013 4.50834 8.52352 4.51871 8.51283C4.52882 8.5024 4.53791 8.5 4.54545 8.5ZM10 13.25C10.4142 13.25 10.75 12.9142 10.75 12.5C10.75 12.0858 10.4142 11.75 10 11.75H9.9995H9.999C9.58479 11.75 9.249 12.0858 9.249 12.5C9.249 12.9142 9.58479 13.25 9.999 13.25H9.9995H10Z"
      fill="currentColor"
    />
  </svg>
);
